import React from 'react'

const { BlobTableResults } = require( './BlobTableResults' )
const { TableResults } = require( './TableResults' )
const { MapResults } = require( './MapResults' )

const types = {
  [BlobTableResults.TYPE] : BlobTableResults,
  [TableResults.TYPE] : TableResults,
  [MapResults.TYPE] : MapResults
}

function factory( type, results, props ) {
  const Clazz = types[type]

  if ( Clazz ) {
    return <Clazz results={results} {...props} />
  }
  return null
}

exports.factory = factory
